<div class="flex flex-row space-x-6">
	<div
		[style.backgroundImage]="
			'url(' + (coach?.pictureUrl || picturePlaceholder) + ')'
		"
		class="bg-center bg-cover rounded-full w-36 h-36 flex-none"
	></div>
	<div class="flex flex-col space-y-1">
		<div class="self-stretch font-semibold text-xl leading-none">
			{{ coach?.name }}
		</div>
		<div class="self-stretch space-x-1">
			<i class="fas fa-envelope"></i>
			<span>{{ coach?.emailAddress || '-' }}</span>
		</div>
		<div class="self-stretch space-x-1">
			<i class="fas fa-phone-alt"></i>
			<span>{{ coach?.phoneNumber || '-' }}</span>
		</div>
	</div>
</div>
<div class="flex flex-row space-x-6">
	<div class="w-36"></div>
	<div class="space-x-3">
		<button
			*ngIf="coach"
			[title]="'presentation.app.page.profile.coach.sendMail.label' | translate"
			(click)="onSendEmailClick(coach.emailAddress)"
			class="text-lg leading-none"
			icon="fa fa-envelope"
			pButton
		></button>
		<button
			*ngIf="(showMeetingButton$ | async) && !!coach"
			[routerLink]="['/booth/availabilities/', coach.id]"
			[title]="
				'presentation.app.page.coaching.booth.card.meeting.label' | translate
			"
			class="text-lg leading-none"
			icon="fa fa-calendar-plus"
			pButton
		></button>
	</div>
</div>
